import { EmployeeMutationDTO, EmployeeMutationSTO } from "../../models/employees";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesCurrentMutationsApiService extends BaseApiService<EmployeeMutationDTO, EmployeeMutationSTO> {
  constructor() {
    super({
      servicePath: "/EmployeeMutations",
      loadItemsPath: "/GetCurrentEmployeeMutations",
      saveItemsPath: "/SaveCurrentEmployeeMutations",
    });
  }
}
